"use client";

import { useState, useEffect, useRef } from "react";

const pages = [
  "/img/Company-Profile/Company-1.png",
  "/img/Company-Profile/Company-2.png",
  "/img/Company-Profile/Company-3.png",
  "/img/Company-Profile/Company-4.png",
  "/img/Company-Profile/Company-5.png",
  "/img/Company-Profile/Company-6.png",
  "/img/Company-Profile/Company-7.png",
  "/img/Company-Profile/Company-8.png",
  "/img/Company-Profile/Company-9.png",
  "/img/Company-Profile/Company-10.png",
  "/img/Company-Profile/Company-11.png",
  "/img/Company-Profile/Company-12.png",
  "/img/Company-Profile/Company-13.png",
  "/img/Company-Profile/Company-14.png",
  "/img/Company-Profile/Company-15.png",
];

export default function CompanyProfileSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const sliderRef = useRef<HTMLDivElement | null>(null);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  /* Scroll ke slide aktif */
  useEffect(() => {
    if (!sliderRef.current || isDragging) return;

    const slideWidth = sliderRef.current.offsetWidth;
    sliderRef.current.scrollTo({
      left: currentIndex * slideWidth,
      behavior: "smooth",
    });
  }, [currentIndex, isDragging]);

  /* DRAG START */
  const handleDragStart = (
    e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    setIsDragging(true);

    startX.current =
      "touches" in e ? e.touches[0]?.pageX || 0 : e.pageX;

    scrollLeft.current = sliderRef.current?.scrollLeft || 0;
  };

  /* DRAG MOVE */
  const handleDragMove = (
    e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    if (!isDragging || !sliderRef.current) return;

    const x =
      "touches" in e ? e.touches[0]?.pageX || 0 : e.pageX;

    const walk = (startX.current - x) * 1.2;
    sliderRef.current.scrollLeft = scrollLeft.current + walk;
  };

  /* DRAG END */
  const handleDragEnd = () => {
    if (!sliderRef.current) return;

    setIsDragging(false);

    const slideWidth = sliderRef.current.offsetWidth;
    const newIndex = Math.round(
      sliderRef.current.scrollLeft / slideWidth
    );

    setCurrentIndex(
      Math.max(0, Math.min(newIndex, pages.length - 1))
    );
  };

  return (
    <div className="relative w-full overflow-hidden py-6 mb-2 bg-secondary-100">
      {/* Title */}
      <div className="flex flex-col mx-auto text-center mb-2 md:mb-8 items-center">
        <h2 className="text-white text-2xl font-body font-bold sm:text-4xl leading-relaxed">
          Company Profile
        </h2>
        <div className="border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5" />
      </div>

      {/* Slider */}
      <div
        ref={sliderRef}
        className="flex overflow-x-scroll scrollbar-hide cursor-grab active:cursor-grabbing"
        onMouseDown={handleDragStart}
        onMouseMove={handleDragMove}
        onMouseUp={handleDragEnd}
        onMouseLeave={handleDragEnd}
        onTouchStart={handleDragStart}
        onTouchMove={handleDragMove}
        onTouchEnd={handleDragEnd}
      >
        {pages.map((src, index) => (
          <div
            key={index}
            className="min-w-full flex justify-center px-6"
          >
            <img
              src={src}
              alt={`Company Profile Page ${index + 1}`}
              className="
                max-h-[70vh]
                md:max-h-[55vh]
                w-auto
                rounded-xl
                shadow-lg
                object-contain
                select-none
              "
              draggable={false}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-center gap-2 mt-6"> 
        {pages.map((_, index) => ( 
          <button key={index} onClick={() => setCurrentIndex(index)} 
          className={`h-2 rounded-full transition-all ${ currentIndex === index ? "w-8 bg-blue-600" : "w-2 bg-gray-300" }`} /> ))} 
      </div>
    </div>
  );
}
